import ChatService from '@/services/chat.service';
import axios from "axios";
import {formatDate} from "@/helpers";

export const chatModule = {
    namespaced: true,
    state: {
        activeConversation: {},
        conversations: new Map(),
        message: {},
        messages: new Map(),
        isConnected: false,
        isTyping: false,
        userIsTyping: {},
        socketMessage: '',
        requests: [],
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async listConversation({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listConversation");
            return ChatService.listConversation(axiosSource).then(
                async data => {
                    commit('updateConversationsList', data);
                    await dispatch('clearRequest', "listConversation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createConversation({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createConversation");
            return ChatService.creatConversation(axiosSource, data).then(
                async data => {
                    commit('insertConversation', data);
                    await dispatch('clearRequest', "createConversation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async editConversation({commit, dispatch}, {conversationId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "editConversation");
            return ChatService.editConversation(axiosSource, conversationId, data).then(
                async data => {
                    commit('insertConversation', data);
                    commit('updateActiveConversation', data);
                    await dispatch('clearRequest', "editConversation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listMessage({commit, dispatch}, {conversationId, from, to, append = false}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listMessage");

            return await ChatService.listMessage(conversationId, from, to, axiosSource).then(
                async data => {
                    commit('updateMessagesList', {
                        data: data.messages,
                        append: append,
                    });
                    await dispatch('clearRequest', "listMessage");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async newMessage({commit, dispatch}, {conversationId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "newMessage");
            return ChatService.newMessage(axiosSource, conversationId, data).then(
                async data => {
                    commit('insertMessage', data);
                    await dispatch('clearRequest', "newMessage");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        setActiveConversation({commit}, data) {
            commit('updateActiveConversation', data);
        },
        async localNewMessage({commit}, data) {
            commit('refreshMessage', data);
        },
        SOCKET_CONNECT({commit}) {
            commit('updateIsConnect', true);
        },
        SOCKET_DISCONNECT({commit}) {
            commit('updateIsConnect', false);
        },
        SOCKET_ERR_MESSAGE(state, data) {
            console.log("Err: ", data)
        },
        SOCKET_REFRESH_MESSAGE({commit}, data) {
            commit('refreshMessage', data);
        },
        SOCKET_TYPING({commit}, data) {
            commit('updateIsTyping', data);
        },
    },
    mutations: {
        updateIsConnect(state, data) {
            state.isConnected = data;
        },
        updateIsTyping(state, data) {
            state.isTyping = true;
            state.userIsTyping = data.user
            setTimeout(() => {
                state.isTyping = false
                state.userIsTyping = {}
            }, 2000)
        },
        updateConversationsList(state, data) {
            state.conversations = new Map()
            for (const entity of data) {
                state.conversations.set(entity.id, entity)
            }
        },
        updateMessagesList(state, {data, append}) {
            if (!append)
                state.messages = new Map()

            let prevDayData = null
            let isNewDay = false

            for (const entity of data) {
                let date = formatDate(entity.createdAt)

                if (!prevDayData) {
                    isNewDay = true
                    prevDayData = date
                } else if (prevDayData !== date) {
                    prevDayData = date
                    isNewDay = true
                } else {
                    isNewDay = false
                }

                entity.isNewDay = isNewDay

                state.messages.set(entity.clientId, entity)

            }

            let preSortArray = [];

            for (const item of state.messages.values())
                preSortArray.push(item)

            preSortArray = preSortArray.sort(function (a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt)
            });

            state.messages = new Map()
            for (const entity of preSortArray) {
                state.messages.set(entity.clientId, entity)
            }

        },
        insertConversation(state, data) {
            state.conversations.set(data.id, data)
        },
        updateActiveConversation(state, data) {
            if (!data) return

            state.activeConversation = data
        },
        async refreshMessage(state, data) {
            const authPersistent = JSON.parse(localStorage.getItem('authPersistent'));
            if (!authPersistent) return;

            if (data.conversationId === state.activeConversation.id)
                state.messages.set(data.data.clientId, data.data)

            state.conversations.get(data.conversationId).last_message = data.data

            if (!data.data.isSeen && (data.data?.author?.id !== authPersistent.user?.id))
                state.conversations.get(data.conversationId).unseen_count += 1
        },
        insertMessage(state, data) {
            state.messages.set(data.data.clientId, data.data)
            state.conversations.get(data.conversationId).last_message = data.data
        },
    }
};